// Build-time configuration. Only publishable values may live in VITE_* variables.

/** Public URL of the snap-cook-recipes R2 bucket (reported by the "Sync recipe photos to R2" workflow). */
const R2_PHOTOS = 'https://pub-57660942b6aa4fe2988d540373b6f9d2.r2.dev';

export const config = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.replace(/\/$/, '') ?? '',
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  appVersion: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '2.0.0',
  /** Where recipe photos are served from (the snap-cook-recipes R2 bucket). Empty serves them from this site. */
  /** Opening a recipe needs a free account (when accounts are available). VITE_RECIPE_GATE=off turns it off. */
  recipeGate: (import.meta.env.VITE_RECIPE_GATE as string | undefined) !== 'off',
  /** Cloudflare Turnstile site key (publishable). Set it, deploy, THEN enable CAPTCHA in Supabase Auth. */
  turnstileSiteKey: (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? '',
  imageBaseUrl: ((import.meta.env.VITE_IMAGE_BASE_URL as string | undefined) ?? R2_PHOTOS).replace(/\/$/, ''),
  /**
   * Affiliate tracking links per store (publishable), from each store's affiliate programme
   * (Instacart, Walmart and Target all run theirs on Impact). Each is a link template with {url}
   * where the store link goes, e.g. https://goto.walmart.com/c/ID/ID/ID?u={url}. Unset: plain links.
   */
  affiliate: {
    instacart: (import.meta.env.VITE_AFFILIATE_INSTACART as string | undefined) ?? '',
    walmart: (import.meta.env.VITE_AFFILIATE_WALMART as string | undefined) ?? '',
    target: (import.meta.env.VITE_AFFILIATE_TARGET as string | undefined) ?? '',
  },
};

/** True when a backend is configured, enables real photo detection and the events pipeline. */
export const hasBackend = Boolean(config.supabaseUrl && config.supabaseAnonKey);
